import axios from 'axios';
import filters from './filters';

const search = {
	peoplePage: document.querySelector('.js-main-people'),
	newsPage: document.querySelector('.js-main-news'),
	portfolioPage: document.querySelector('.js-main-portfolio'),
	searchForms: document.querySelectorAll('.js-search'),
	searchBtns: document.querySelectorAll('.js-search-btn'),
	filterMobileBtn: document.querySelector('.js-filter-mobile'),
	filterActiveContainer: document.querySelector(
		'.js-filter-active-container'
	),
	placeholder: document.querySelectorAll('.js-placeholder'),
	searchFormOpen: 'filters__search--open',
	searchResultsActive: 'search-results--active',
	filterMobileBtnClose: 'filters__mobile-btn--close',
	inputTextClass: 'filters__search-text--show',

	isAnimated: false,

	init: function() {
		this.searchForms.forEach((form, index) => {
			this.preventFormSubmit(form);
			this.setupInputAnimation(this.searchBtns[index], index);
			this.setupSubmitOnEnter(form);
		});
		this.openFilterBtn();
	},

	preventFormSubmit: function(form) {
		form.addEventListener('submit', (e) => {
			e.preventDefault();
		});
	},

	setupInputAnimation: function(button, index) {
		button.addEventListener('click', (e) => {
			e.preventDefault();

			const searchForm = this.searchForms[index];
			const inputText = searchForm.querySelector('.js-input-text');
			const input = searchForm.querySelector('.js-search-input');

			if (!this.isAnimated) {
				this.filterMobileBtn.disabled = true;
				this.animateInput(searchForm, input, inputText);
				this.isAnimated = true;
			} else {
				if (!input.value.trim()) {
					this.closeSearchForm(searchForm, inputText, input);
				} else {
					this.submitInput(input);
				}
			}
		});
	},

	closeSearchForm: function(searchForm, inputText, input) {
		searchForm.classList.remove(this.searchFormOpen);
		this.filterMobileBtn.textContent = 'Filter';
		this.filterMobileBtn.classList.remove(this.filterMobileBtnClose);

		inputText.classList.remove(this.inputTextClass);
		this.placeholder.forEach((holder) => {
			holder.classList.remove('filters__search-placeholder--active');
		});

		input.value = '';
		input.placeholder = '';
		this.isAnimated = false;
		setTimeout(() => {
			input.blur();
		}, 1201);
	},

	animateInput: function(searchForm, input, inputText) {
		searchForm.classList.add(this.searchFormOpen);
		this.filterMobileBtn.textContent = '';
		this.filterMobileBtn.classList.add(this.filterMobileBtnClose);

		inputText.classList.add(this.inputTextClass);
		setTimeout(() => {
			this.filterMobileBtn.disabled = false;
			input.focus();
			inputText.classList.remove(this.inputTextClass);
			// input.placeholder = 'Type here';
			this.placeholder.forEach((holder) => {
				holder.classList.add('filters__search-placeholder--active');
			});
		}, 1200);

		input.addEventListener('input', () => {
			this.placeholder.forEach((holder) => {
				if (input.value.trim() !== '') {
					holder.classList.remove(
						'filters__search-placeholder--active'
					);
				} else {
					holder.classList.add('filters__search-placeholder--active');
				}
			});
		});
	},

	openFilterBtn: function() {
		if (!this.filterMobileBtn) return;
		this.filterMobileBtn.addEventListener('click', () => {
			this.filterMobileBtn.disabled = false;
			this.searchForms.forEach((form) => {
				const inputText = form.querySelector('.js-input-text');
				const input = form.querySelector('.js-search-input');

				inputText.classList.remove(this.inputTextClass);
				form.classList.remove(this.searchFormOpen);
				this.filterMobileBtn.textContent = 'Filter';
				this.filterMobileBtn.classList.remove(
					this.filterMobileBtnClose
				);
				input.value = '';
				input.placeholder = '';
			});
			this.isAnimated = false;
		});
	},

	setupSubmitOnEnter: function(form) {
		const input = form.querySelector('.js-search-input');
		input.addEventListener('keypress', (e) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				this.submitInput(input);
			}
		});
	},

	submitInput: function(input) {
		const inputValue = input.value;
		filters.clearFilterOnSubmit();
		if (this.peoplePage) {
			this.callAxiosPeople(inputValue, 1);
		} else if (this.newsPage) {
			this.callAxiosNews(inputValue, 1);
		} else if (this.portfolioPage) {
			this.callAxiosPortfolio(inputValue, 1);
		}
	},

	callAxiosNews: function(searchTerm, pageNumber) {
		const gridWrapper = document.querySelector('.js-grid-wrapper');
		const pageKey = gridWrapper.dataset.gridPageId;
		const itemsPerPage = gridWrapper.dataset.itemsPerPage;
		const orderBy = gridWrapper.dataset.orderBy;
		const path = '/umbraco/api/newsListing/searchNews';
		const params = {
			pageKey,
			searchTerm,
			orderBy,
			pageNumber,
			itemsPerPage,
		};

		axios.get(path, { params }).then((response) => {
			const btnSubmit = document.querySelector('.js-search-btn');
			btnSubmit.focus();
			const data = response.data;
			const htmlContent = data.html;
			const gridPrimaryWrapper = document.querySelector(
				'.js-primary-wrapper'
			);
			gridPrimaryWrapper.innerHTML = htmlContent;

			this.onPaginationBtnSearch(searchTerm);
			filters.onClickScrollToTop();
			this.clearSearch();
			const searchResults = document.querySelector('.js-serach-results');
			if (searchResults) {
				if (
					!searchResults.classList.contains(this.searchResultsActive)
				) {
					searchResults.classList.add(this.searchResultsActive);
				}
			}
		});
	},

	callAxiosPeople: function(searchTerm, pageNumber) {
		const gridWrapper = document.querySelector('.js-grid-wrapper');
		const pageKey = gridWrapper.dataset.gridPageId;
		const itemsPerPage = gridWrapper.dataset.itemsPerPage;
		const path = '/umbraco/api/peopleListing/searchPeople';
		const params = {
			pageKey,
			searchTerm,
			pageNumber,
			itemsPerPage,
		};

		axios.get(path, { params }).then((response) => {
			const btnSubmit = document.querySelector('.js-search-btn');
			btnSubmit.focus();
			const data = response.data;
			const htmlContent = data.html;
			const gridPrimaryWrapper = document.querySelector(
				'.js-primary-wrapper'
			);
			gridPrimaryWrapper.innerHTML = htmlContent;

			this.onPaginationBtnSearch(searchTerm);
			filters.onClickScrollToTop();
			this.clearSearch();
			const searchResults = document.querySelector('.js-serach-results');
			if (searchResults) {
				if (
					!searchResults.classList.contains(this.searchResultsActive)
				) {
					searchResults.classList.add(this.searchResultsActive);
				}
			}
		});
	},

	callAxiosPortfolio: function(searchTerm, pageNumber) {
		const gridWrapper = document.querySelector('.js-grid-wrapper');
		const pageKey = gridWrapper.dataset.gridPageId;
		const itemsPerPage = gridWrapper.dataset.itemsPerPage;
		const path = '/umbraco/api/portfolioListing/searchPortfolioItems';
		const params = {
			pageKey,
			searchTerm,
			itemsPerPage,
			pageNumber,
		};

		axios.get(path, { params }).then((response) => {
			const btnSubmit = document.querySelector('.js-search-btn');
			btnSubmit.focus();
			const data = response.data;
			const htmlContent = data.html;
			const gridPrimaryWrapper = document.querySelector(
				'.js-primary-wrapper'
			);
			gridPrimaryWrapper.innerHTML = htmlContent;

			this.onPaginationBtnSearch(searchTerm);
			filters.onClickScrollToTop();
			this.clearSearch();
			const searchResults = document.querySelector('.js-serach-results');
			if (searchResults) {
				if (
					!searchResults.classList.contains(this.searchResultsActive)
				) {
					searchResults.classList.add(this.searchResultsActive);
				}
			}
		});
	},

	onPaginationBtnSearch: function(searchTerm) {
		const paginationBtns = document.querySelectorAll('.js-pagination-btn');
		if (!paginationBtns) return;
		paginationBtns.forEach((btn) => {
			const pageNumber = btn.getAttribute('data-page-number');

			if (pageNumber === '...') {
				btn.classList.add('pagination__btn--disabled');
				return;
			}

			btn.addEventListener('click', (event) => {
				event.preventDefault();
				const isDisabled = btn.classList.contains(
					'pagination__btn--disabled'
				);

				if (isDisabled) return;

				if (this.peoplePage) {
					this.callAxiosPeople(searchTerm, pageNumber);
				} else if (this.newsPage) {
					this.callAxiosNews(searchTerm, pageNumber);
				} else if (this.portfolioPage) {
					this.callAxiosPortfolio(searchTerm, pageNumber);
				}
			});
		});
	},

	clearSearch: function() {
		const clearSearchBtn = document.querySelector('.js-clear-search');
		if (!clearSearchBtn) return;
		const searchResults = document.querySelector('.js-serach-results');

		clearSearchBtn.addEventListener('click', () => {
			this.searchForms.forEach((form) => {
				form.classList.remove(this.searchFormOpen);

				const input = form.querySelector('.js-search-input');
				if (input) {
					input.value = '';
					input.placeholder = '';
				}
				this.placeholder.forEach((holder) => {
					holder.classList.remove(
						'filters__search-placeholder--active'
					);
				});
			});

			this.isAnimated = false;
			this.filterMobileBtn.textContent = 'Filter';
			this.filterMobileBtn.classList.remove(this.filterMobileBtnClose);

			if (this.peoplePage) {
				this.callAxiosPeople('', 1);
			} else if (this.newsPage) {
				this.callAxiosNews('', 1);
			} else if (this.portfolioPage) {
				this.callAxiosPortfolio('', 1);
			}
			if (searchResults) {
				searchResults.classList.remove(this.searchResultsActive);
			}
		});
	},

	clearSearchOnFilters: function() {
		const searchResults = document.querySelector('.js-serach-results');
		this.searchForms.forEach((form) => {
			form.classList.remove(this.searchFormOpen);
			const input = form.querySelector('.js-search-input');
			if (input) {
				input.value = '';
				input.placeholder = '';
			}
		});

		this.isAnimated = false;
		this.filterMobileBtn.textContent = 'Filter';
		this.filterMobileBtn.classList.remove(this.filterMobileBtnClose);
		if (searchResults) {
			searchResults.classList.remove(this.searchResultsActive);
		}
	},
};

export default search;
